import React, { useState } from 'react';
import { ILookupField , IContact, IField } from '../../shared/interfaces';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import { mergeStyleSets, IMessageBarProps, Persona, PersonaSize, IPersonaProps } from '@fluentui/react';
import { RootState } from '../../store';
import { useSelector } from 'react-redux';
import DynamicForm from '../DynamicForm/DynamicForm';

import { useBoolean } from '@fluentui/react-hooks';
import ContactInfo from '../../sharedComponents/ContactInfo';



const classNames = mergeStyleSets({
    scrollablePaneWrapper: {
        position: 'relative',
        height: '100%',
    },

    inputWrapper:
    {
        paddingBottom: '20px',

    },
    compactCard: {
        alignItems: 'center',
        padding: "0 20px"
    },
    expandedCard: {
        padding: '16px 24px'
    },
    iconClass: {
        fontSize: 20,
        margin: '0 25px'
    },
    contactInfoGroup: {
        padding: '4px 0px',
    },

    address: {
        height: '20px'
    }

});




export interface RubricaFormProps {
    extraCssClass?: string
    onError: (errorMessageProps: IMessageBarProps) => void
}




const RubricaForm: React.FunctionComponent<RubricaFormProps> = (props) => {


    let [loading, { setTrue: showLoader, setFalse: hideLoader }] = useBoolean(false);

    let [rubricaFormFields, setRubricaFormFields] = useState<IField[]>([
        {
            displayName: "Ricerca un contatto della rubrica",
            internalName: "rubrica",
            list: "Rubrica", ///Utilizzando "Rubrica" capisco che devo puntare alla rubrica arxeia
            sharepointType: "",
            controlType: "autocompleteContact",
            required: false,
            readonly: false,
            disabled: false,
            system: false,
            internalValue: [],
            valid: false,
            touched: false,
            multi: false,
        } as ILookupField 
    ]);


    let [contactCard, setContactCard] = useState<IContact | undefined>(undefined);
    let [persProps, setPersProps] = useState<IPersonaProps | undefined>(undefined);

    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);


    const onInputChangedHandler = (updatedField: IField) => {
        const updatedRubricaFields = [...(rubricaFormFields ?? [])];
        let itemIndex = updatedRubricaFields.findIndex(el => el.internalName === updatedField.internalName);/// l'inertnalName è sempre rubrica
        updatedRubricaFields[itemIndex] = { ...updatedField };

        setRubricaFormFields([...updatedRubricaFields]);
        if (updatedField.internalValue && updatedField.internalValue.length === 1) {
            let internalValue = updatedField.internalValue[0];
            let { contact, ...persProps } = internalValue;
            setContactCard(contact);
            setPersProps(persProps);
        } else {
            setContactCard(undefined);
            setPersProps(undefined);
        }
    }

    const renderContactInfo = (): JSX.Element => {


        return (
            <React.Fragment>
                <div className={classNames.compactCard}>
                    <Persona
                        {...persProps}
                        size={PersonaSize.size56}
                        hidePersonaDetails={false}
                    />
                </div>
                <div className={classNames.expandedCard}>
                    {contactCard &&
                        <ContactInfo contactCard={contactCard}></ContactInfo>
                    }
                </div>
            </React.Fragment>

        );
    }

    return (
        <React.Fragment>

            <CircleLoader loaderClass='loader-large' loading={loading} />

            <div className={"flex flex-column position-relative overflow-hidden"}>

                <div className={`position-relative my-scroll-div`}>
                    <DynamicForm
                        fields={rubricaFormFields}
                        onInputChangedHandler={(updatedField) => { onInputChangedHandler(updatedField) }}
                    />

                    {contactCard && persProps &&
                        renderContactInfo()
                    }
                </div>

            </div>

        </React.Fragment>
    );
}

export default RubricaForm;


